import themeManager from "common/managers/themeManager";

const popupWidgetSelector = [
    "dfdropdownlist",
    "possiblyfilterabledropdownlist",
    "dfcombobox",
    "dfdatepicker"
].map((role) => `[data-role="${role}"]`).join();

function getPopup(element, setId = false) {
    const widget = kendo.widgetInstance($(element));
    const popup = widget?.popup || widget?.dateView?.popup;
    if(!popup) {
        return;
    }
    if(setId && !popup.element.attr("id")) {
        popup.element.attr("id", `_${kendo.guid()}`);
    }
    return popup.element[0];
}

function apply(element, properties) {
    element && themeManager.apply(element, properties);
}

function remove(element) {
    element && themeManager.remove(element);
}

const ThemeBinding = kendo.data.Binder.extend({
    refresh() {
        this.setTheme(this.bindings.theme.get());
    },

    setTheme(properties) {
        const widgets = $(this.getElement()).find(popupWidgetSelector).toArray();
        const element = this.getElement();
        if(properties && properties !== true) {
            apply(element, properties);
            widgets.forEach((el) => {
                apply(getPopup(el, true), properties);
            });
        } else {
            remove(element);
            widgets.forEach((el) => {
                remove(getPopup(el));
            });
        }
    },

    getElement() {
        return this.element;
    }
});

kendo.data.binders.theme = ThemeBinding;

/**
 * A theme binding. A theme may be null, undefined, true, or an object of theme properties.
 * null or undefined mean that this widget should not be themed.
 * true means that this widget is themed, but properties do not need to be applied as they are already applied globally.
 * an object of theme properties will be applied and the widget will be informed.
 * @type {kendo.data.Binder}
 */
kendo.data.binders.widget.theme = ThemeBinding.extend({
    setTheme(properties) {
        ThemeBinding.fn.setTheme.apply(this, arguments);
        this.element.setIsThemed && this.element.setIsThemed(!!properties);
    },

    getElement() {
        return (this.element.wrapper || this.element.element)[0];
    }
});
